import fichoAzul from '../imgs/fichos/Ficho-azul.png';
import fichoRojo from '../imgs/fichos/Ficho-rojo.png';
import fichoVerde from '../imgs/fichos/Ficho-verde.png';
import fichoAmarillo from '../imgs/fichos/Ficho-amarillo.png';

let casillas = {
    casilla1:[
        {
            id: "1",
            img: fichoAzul
        },
        {
            id: "2",
            img: fichoRojo
        },
        {
            id: "3",
            img: fichoVerde
        },
        {
            id: "4",
            img: fichoAmarillo
        }
    ],
    casilla2:[
    ],
    casilla3:[
    ],
    casilla4:[
    ],
    casilla5:[
    ],
    casilla6:[
    ],
    casilla7:[
    ],
    casilla8:[
    ],
    casilla9:[
    ],
    casilla10:[
    ],
    casilla11:[
    ],
    casilla12:[
    ],
    casilla13:[
    ],
    casilla14:[
    ],
    casilla15:[
    ],
    casilla16:[
    ],
    casilla17:[
    ],
    casilla18:[
    ],
    casilla19:[
    ],
    casilla20:[
    ],
    casilla21:[
    ],
    casilla22:[
    ],
    casilla23:[
    ],
    casilla24:[
    ],
    casilla25:[
    ],
    casilla26:[
    ],
    casilla27:[
    ],
    casilla28:[
    ],
    casilla29:[
    ],
    casilla30:[
    ],
    casilla31:[
    ],
    casilla32:[
    ],
    casilla33:[
    ],
    casilla34:[
    ],
    casilla35:[
    ],
    casilla36:[
    ],
    casilla37:[
    ],
    casilla38:[
    ],
    casilla39:[
    ],
    casilla40:[
    ],
    casilla41:[
    ],
    casilla42:[
    ],
    casilla43:[
    ],
    casilla44:[
    ],
    casilla45:[
    ],
    casilla46:[
    ],
    casilla47:[
    ],
    casilla48:[
    ],
    casilla49:[
    ],
    casilla50:[
    ],
};

export { casillas };